import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Scans a canvas from the bottom upward and returns a new canvas
 * cropped to the last row that contains non-white pixels + padding.
 */
function trimCanvasBottom(canvas, paddingPx = 20) {
  const ctx = canvas.getContext("2d");
  const { width, height } = canvas;
  const imageData = ctx.getImageData(0, 0, width, height);
  const data = imageData.data;

  let lastContentRow = 0;

  for (let y = height - 1; y >= 0; y--) {
    let rowHasContent = false;
    for (let x = 0; x < width; x++) {
      const idx = (y * width + x) * 4;
      const r = data[idx];
      const g = data[idx + 1];
      const b = data[idx + 2];
      const a = data[idx + 3];
      // A pixel with alpha > 0 and not near-white is considered "content"
      if (a > 0 && !(r > 248 && g > 248 && b > 248)) {
        rowHasContent = true;
        break;
      }
    }
    if (rowHasContent) {
      lastContentRow = y;
      break;
    }
  }

  const trimmedHeight = Math.min(lastContentRow + paddingPx, height);

  const trimmed = document.createElement("canvas");
  trimmed.width = width;
  trimmed.height = trimmedHeight;
  trimmed.getContext("2d").drawImage(
    canvas,
    0, 0, width, trimmedHeight,   // source rect
    0, 0, width, trimmedHeight    // dest rect
  );

  return trimmed;
}

export const DownloadDocument = async (
  setLoading,
  invoiceDownloadId,
  documentTitle,
  shouldDownload
) => {
  setLoading(true);

  const htmlEl = document.documentElement;
  const savedZoom = htmlEl.style.zoom;

  try {
    const element = document.getElementById("divToPrint");
    if (!element) throw new Error("divToPrint not found!");

    const target = element.querySelector(".Invoice-details") || element;

    // Reset zoom so html2canvas measures at 100% scale
    htmlEl.style.zoom = "1";
    await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));

    // Capture the invoice element
    const rawCanvas = await html2canvas(target, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      logging: false,
    });

    // Restore zoom immediately
    htmlEl.style.zoom = savedZoom;

    // Trim blank rows from the bottom of the canvas
    const canvas = trimCanvasBottom(rawCanvas, 30);

    const imgData = canvas.toDataURL("image/jpeg", 1.0);

    // Use 210mm (A4 width) and calculate height to match the trimmed canvas exactly.
    // This makes the PDF page exactly as tall as the invoice — no blank bottom space.
    const pdfWidth  = 210; // mm
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width; // exact content height

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [pdfWidth, pdfHeight], // custom page size = exact invoice size
    });

    pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);

    if (shouldDownload) {
      pdf.save(`${documentTitle}.pdf`);
    }

    return pdf;
  } catch (error) {
    console.error("PDF Error:", error);
    htmlEl.style.zoom = savedZoom;
    throw error;
  } finally {
    setLoading(false);
  }
};